
import LoaderIcon from '../assets/icons/loader-dot.svg'
import Forbidden from '../assets/icons/forbidden.svg'



const ICONS = {
  LoaderIcon,Forbidden
};


export default {
  ...ICONS
};